export const MODAL_TYPES = {
  WARNING: 'warning',
  QUESTION: 'help',
  INFO: 'info',
};
